import { Listing, TransactionType, ListingStatus } from '../../../types';

/**
 * Predicate to check if a listing is a "space" listing (Prenájom or has space details).
 * Filters out listings that are not in 'Slovensko' if country is specified.
 */
export function isSpaceListing(listing: Listing): boolean {
    const tt = listing.transactionType;
    if (tt === TransactionType.RENT) return true;

    const sd = listing.spaceDetails;
    if (!sd) return false;

    const country = sd.address?.country;
    if (country && country !== 'Slovensko') return false;

    return true;
}

/**
 * Predicate to check if a listing is approved.
 */
export function isApproved(listing: Listing): boolean {
    return listing.status === ListingStatus.APPROVED;
}
